import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as apicall from "../../components/Apicall";

const industries = [
  "Healthcare",
  "Deep Cleaning",
  "Pest Control",
  "Women Salon",
  "Handyman",
  "Item Moving",
  "AC Services",
  "Furniture Cleaning",
  "Landscaping",
  "Packers & Movers",
  "Painting",
  "Water Tank",
];

const Industry = () => {
  const [selected, setSelected] = useState("");
    const [industry, setIndustries] = useState([]);

  
  const navigate = useNavigate();

  const handleContinue = () => {
    if (!selected){
        toast.error("Please select an industry to continue.");
        return;
    }
    navigate("/service-location",{state : selected});
  };
 useEffect(() => {
    getIndustries();
  }, []);

  const getIndustries = async () => {
    try {
      const res = await apicall.get("getIndustries");

      if (res.success) {
        setIndustries(res.data);
      }
    } catch (err) {
      console.log(err);
    }
  };
return (
  <div style={{ background: "#fff", minHeight: "80vh" ,padding: "30px 0"}}>
    <div className="container mt-3">
      <h3>Select your Industry</h3>
      <p className="text-muted">
        This will help us to setup your requirement much better.
      </p>

    <div className="row mt-4">
  {industry.map((item) => (
    <div key={item.id} className="col-6 col-md-3 mb-3">
      <div
        onClick={() => setSelected(item)}
        className={`p-3 border rounded text-center`}
        style={{
          background: selected?.id === item.id ? "#d01c4c" : "#fff",
          color: selected?.id === item.id ? "#fff" : "#000",
          border:
            selected?.id === item.id
              ? "1px solid #d01c4c"
              : "1px solid #ddd",
          cursor: "pointer",
          fontWeight: 500,
        }}
      >
        {item.name}
      </div>
    </div>
  ))}
</div>

      <button className="btn btn-danger" onClick={handleContinue}>
        Continue
      </button>
    </div>
  </div>
);
};

export default Industry;